import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { FULL_SQUAD, POSITION_ORDER, POSITION_LABELS } from "@/data/teamData";
import Footer from "@/components/Footer";

export default function Skuad() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Kelompokkan pemain berdasarkan posisi
  const grouped = POSITION_ORDER.map((pos) => ({
    position: pos,
    label: POSITION_LABELS[pos],
    players: FULL_SQUAD.filter((p) => p.position === pos),
  })).filter((g) => g.players.length > 0);

  return (
    <div data-testid="squad-page" className="bg-[#050B14] text-white min-h-screen">
      {/* Header */}
      <header className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <img src="/30sff-logo.png" alt="The 30s FF" className="w-11 h-11 object-contain" />
            <div className="leading-none">
              <div className="font-display text-lg sm:text-xl tracking-wider">THE 30s FF</div>
              <div className="text-[10px] text-white/50 tracking-[0.2em]">OFFICIAL TEAM</div>
            </div>
          </Link>
          <Link
            to="/#skuad"
            data-testid="squad-back"
            className="inline-flex items-center gap-2 text-xs font-bold tracking-wider text-white/80 hover:text-[#E63946] transition-colors"
          >
            <ArrowLeft size={14} /> KEMBALI
          </Link>
        </div>
      </header>

      {/* Title */}
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-10">
        <div className="text-xs font-bold tracking-[0.3em] text-[#E63946] mb-3">PUNGGAWA LENGKAP</div>
        <h1 className="font-display text-5xl sm:text-6xl leading-none">
          SKUAD <span className="text-[#E63946]">THE 30s FF</span>
        </h1>
        <p className="mt-4 text-white/70 max-w-2xl">
          Total {FULL_SQUAD.length} pemain yang membela panji tim di setiap laga.
          Dari penjaga gawang hingga lini depan.
        </p>
      </div>

      {/* Players grouped by position */}
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pb-20 space-y-14">
        {grouped.map((group) => (
          <div key={group.position}>
            <div className="flex items-center gap-4 mb-6">
              <h2 className="font-display text-2xl sm:text-3xl tracking-wide">{group.label}</h2>
              <span className="text-xs text-white/40">{group.players.length} pemain</span>
              <div className="flex-1 h-px bg-white/10" />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {group.players.map((p) => (
                <Link
                  key={p.id}
                  to={`/pemain/${p.id}`}
                  data-testid={`squad-full-card-${p.id}`}
                  className="group relative block bg-[#0A1128] border border-white/10 card-hover overflow-hidden"
                >
                  <div className="aspect-[3/4] relative overflow-hidden">
                    <img
                      src={p.img}
                      alt={p.name}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128] via-[#0A1128]/40 to-transparent" />
                    {p.num && (
                      <div className="absolute top-3 right-3 font-display text-4xl text-white/30 group-hover:text-[#E63946] transition-colors">
                        {p.num}
                      </div>
                    )}
                  </div>
                  <div className="p-4 border-t border-white/10">
                    <div className="font-display text-lg leading-tight">{p.name}</div>
                    <div className="text-[10px] tracking-[0.2em] text-white/50 mt-1">{p.positionLabel || p.position}</div>
                  </div>
                  <div className="absolute top-0 left-0 w-1 h-0 bg-[#E63946] group-hover:h-full transition-all duration-500" />
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
}
